<template>
    <el-dialog title="选择导出题型" :visible.sync="dialogVisible" width="500px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="form" ref="form">
            <el-form-item label="导出题型">
                <el-checkbox v-model="form.objective">客观题（单选题、多选题、不定项选择题、判断题、填空题）</el-checkbox>
                <el-checkbox v-model="form.subjectivity" v-if="row.haveSubjective">主观题</el-checkbox>
            </el-form-item>
            <span>提示：脚本评阅主观题导出内容包含题目答案文本、附件、实操环境日志</span>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">关闭</el-button>
            <el-button type="primary" @click="submitForm()" :loading="loading">导出</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {exportAnswer, getPackageStatus} from "@/api/reviewPlan";

export default {
    name: "exportAnswer",
    props: ['row'],
    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                objective: false,
                subjectivity: true
            },
            ticket: null,
            timer: null,
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    },
    methods: {
        show() {
            this.dialogVisible = true
        },
        submitForm() {
            if (!this.row.haveSubjective) {
                this.form.subjectivity = false
            }
            if (!this.form.objective && !this.row.haveSubjective && !this.form.subjectivity) {
                this.$message.error("未选择导出内容！");
                return
            }
            this.loading = true
            exportAnswer(this.row.id, this.form).then(res => {
                if (res.data.status === 200) {
                    // this.download(this.row.examPlanName + '答卷及附件', res.data.data)
                    this.ticket = res.data.data
                    this.timer = setInterval(this.getPackageStatus, 1500)
                } else {
                    this.$message.error(res.data.message);
                }
            }).catch(() => {
                this.$message.error("导出失败！");
            })
        },
        getPackageStatus() {
            getPackageStatus(this.ticket).then(res => {
                if (res.data.data) {
                    this.loading = false
                    clearInterval(this.timer)
                    this.download(res.data.data, this.row.examPlanName + '-答卷及附件', this.ticket)
                } else if (res.data.status === 500) {
                    clearInterval(this.timer)
                    this.$message.error(res.data.message);
                }
            })
        },
        download(filename, resData, ticket) {
            let a = document.createElement('a')
            let url = `${this.config_env.BASE_URL}/api/review/plan/export_score/download/${filename}/${resData}?ticket=${ticket}`
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
            this.$message({type: 'success', message: filename + '导出成功'})
            this.close()
        },
        close() {
            this.loading = false
            this.dialogVisible = false
            this.form = {
                objective: false,
                subjectivity: true
            }

            if (this.timer) {
                clearInterval(this.timer)
            }
        }
    }
}
</script>

<style scoped>

</style>
